import type { PickerFlushReason } from '@wiztime/core';

/**
 * Registry of the picker's single commit point (2026-10b §5.4). The handler is registered by
 * the picker host (it holds the commands and the day data); `dayUiStore` and the keyboard and
 * route hooks call `flushPicker` before every close or replace path. Without a handler or an
 * open picker there is nothing to commit and the close proceeds.
 */

export interface PickerFlushOptions {
  /** Suppress the "saved" toast (project choose, switching blocks, route changes). */
  readonly silent?: boolean;
}

/** Returns false when the close must not proceed (create context, first dismissal warning). */
export type PickerFlushHandler = (reason: PickerFlushReason, options: PickerFlushOptions) => boolean;

let current: PickerFlushHandler | null = null;

export function registerPickerFlushHandler(handler: PickerFlushHandler): () => void {
  current = handler;
  return () => {
    if (current === handler) current = null;
  };
}

export function flushPicker(reason: PickerFlushReason, options: PickerFlushOptions = {}): boolean {
  return current === null ? true : current(reason, options);
}
